(function ($, document, window) {
    'use strict';

    $(function () {
        const $sidebar = $('.js-sidebar');
        const $siteHeader = $('.js-site-header');
        const $stickyHeader = $('.js-sticky-header');
        const $inPage = $('.js-in-page');
        const breakContentSidebar = getComputedStyle(document.documentElement).getPropertyValue('--break-grid-content-sidebar').trim();

        var matchMediaLg = window.matchMedia(`(min-width: ${breakContentSidebar})`);
        var stickyClass = 'is-sticky';

        function getHeaderHeight() {
            return $('body').hasClass('sticky-header-active')
                ? $stickyHeader.outerHeight()
                : $siteHeader.outerHeight();
        }

        function getInPageHeight() {
            return $inPage.length
                ? $inPage.outerHeight()
                : 0;
        }

        function getAdminBarHeight() {
            return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--wp-admin--admin-bar--height')) || 0;
        }

        /**
         * Determines whether or not the sidebar can be sticky.
         * 
         * @returns {boolean} True if sidebar can be sticky, false otherwise.
         */
        function canSidebarBeSticky() {
            if (!$sidebar.length || !matchMediaLg.matches) {
                return false;
            }

            const headerHeight = getHeaderHeight();
            const inPageHeight = getInPageHeight();
            const adminBarHeight = getAdminBarHeight();
            const sidebarHeight = $sidebar.outerHeight();
            const availableHeight = window.innerHeight - (headerHeight + inPageHeight + adminBarHeight);

            return sidebarHeight < availableHeight;
        }

        /**
         * Handles adding a sticky class to the sidebar if it should stick.
         */
        function handleStickyClass() {
            if (!$sidebar.length || !matchMediaLg.matches) {
                return;
            }

            const scrollTop = $(window).scrollTop();

            if (canSidebarBeSticky()) {
                $sidebar.addClass(stickyClass);
            } else {
                $sidebar.removeClass(stickyClass);
            }
        }

        $(window).on('scroll resize', handleStickyClass);

        handleStickyClass();
    });
})(jQuery, document, window);